import script from "./changeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./changeModal.vue?vue&type=script&setup=true&lang=js"

import "./changeModal.vue?vue&type=style&index=0&id=b47ffd8c&lang=scss"

const __exports__ = script;

export default __exports__